import { useState } from "react";
import { KeyRound } from "lucide-react";
import { toast } from "sonner";
import api, { formatApiErrorDetail } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle, DialogTrigger } from "@/components/ui/dialog";

export default function PasswordChangeDialog() {
  const [open, setOpen] = useState(false);
  const [saving, setSaving] = useState(false);
  const [current, setCurrent] = useState("");
  const [password, setPassword] = useState("");
  const [confirmation, setConfirmation] = useState("");
  const submit = async (event) => {
    event.preventDefault();
    if (password !== confirmation) return toast.error("Konfirmasi password tidak sama");
    setSaving(true);
    try {
      await api.post("/auth/change-password", { current_password: current, new_password: password });
      toast.success("Password berhasil diganti");
      setOpen(false);
    } catch (error) {
      toast.error(formatApiErrorDetail(error.response?.data?.detail));
    } finally { setSaving(false); }
  };
  return (
    <Dialog open={open} onOpenChange={(value) => { if (!saving) { setOpen(value); setCurrent(""); setPassword(""); setConfirmation(""); } }}>
      <DialogTrigger asChild><button className="flex items-center gap-3 px-2 py-2 text-sm text-muted-foreground hover:text-foreground" data-testid="change-password-btn"><KeyRound size={18} /> Ganti Password</button></DialogTrigger>
      <DialogContent className="rounded-none">
        <DialogHeader><DialogTitle>Ganti Password</DialogTitle><DialogDescription>Masukkan password saat ini dan password baru minimal 8 karakter.</DialogDescription></DialogHeader>
        <form onSubmit={submit} className="space-y-4">
          <label className="block text-sm">Password saat ini<Input autoComplete="current-password" type="password" required value={current} onChange={(e) => setCurrent(e.target.value)} /></label>
          <label className="block text-sm">Password baru<Input autoComplete="new-password" type="password" required minLength={8} value={password} onChange={(e) => setPassword(e.target.value)} /></label>
          <label className="block text-sm">Konfirmasi password<Input autoComplete="new-password" type="password" required minLength={8} value={confirmation} onChange={(e) => setConfirmation(e.target.value)} /></label>
          <Button type="submit" disabled={saving} className="rounded-none w-full">{saving ? "Menyimpan..." : "Simpan Password"}</Button>
        </form>
      </DialogContent>
    </Dialog>
  );
}
